var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7106 5.64316L16.7229 5.62924L16.7341 5.61446C17.1282 5.09378 17.0837 4.35414 16.6041 3.88402C16.0818 3.37199 15.2391 3.37199 14.7168 3.88402L7.39587 11.061L7.38278 11.0738L7.37065 11.0876L7.28937 11.1799L7.27711 11.1938L7.26593 11.2086C6.87184 11.7293 6.91632 12.4689 7.39587 12.939L14.7168 20.116L14.7298 20.1288L14.7438 20.1406L14.838 20.2203L14.852 20.2322L14.8668 20.243C15.3892 20.623 16.1284 20.5823 16.6041 20.116L16.6172 20.1031L16.6293 20.0894L16.7106 19.9971L16.7229 19.9832L16.7341 19.9684C17.1282 19.4477 17.0837 18.7081 16.6041 18.2379L16.6041 18.2379L10.2408 12L16.6041 5.76208L16.6172 5.74924L16.6293 5.73547L16.7106 5.64316Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowicon);
export default __webpack_public_path__ + "static/media/arrow.icon.7b84e3183fb79ea465fe9bea9663426c.svg";
export { ForwardRef as ReactComponent };